module.exports = __webpack_public_path__ + "img/3-m.d0c664ca.jpg";